<script>
export default {
  name: 'triageBox',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    hasData: {
      type: Boolean,
      required: false,
      default: true,
    },

    hasBg: {
      type: Boolean,
      required: false,
      default: false,
    },
    noDataTitle: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
<template>
  <v-container
    fluid
    class="rounded-lg relative container-box mx-0"
    :class="{ bg: hasBg }"
    @click="$emit('click')"
  >
    <div class="absolute container-box-title">
      <div class="container-box-title-content">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div class="container-box-title-bg"></div>
    </div>
    <v-row v-if="hasData" class="mt-1 container-box-content"><slot></slot></v-row>
    <v-col v-else cols="12" class="text-center primary-color container-box-no_data">
      {{ noDataTitle }} یافت نشد
    </v-col>
  </v-container>
</template>
<style lang="scss">
.container-box {
  padding-top: 1.5rem;
  position: relative;
  &-title {
    position: absolute;
    padding: 0.05rem 0.2rem;
    background-color: transparent;
    color: var(--v-darkColor-base);
    font-weight: 600;
    top: 0;
    transform: translateY(-50%);
    right: 24px;
    font-size: 16px;
    z-index: 2;
    &-content {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
    }
    &-bg {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 4px;
      background-color: white;
      z-index: 1;
      transform: translateY(-50%);
    }
  }
  &-content {
    height: 100%;
  }
  &-no_data {
    position: absolute;
    top: 50%;
  }
}
.bg {
  background-color: var(--background-color);
}
</style>
